import React, { useState } from 'react'
import {
	DescriptionLabel,
	PrivacyContainer,
	ConditionsLink,
} from './Privacy.styles'
import { Checkbox } from '@welbe/web-design-system'
import { isIOS } from 'utils/device'

type PrivacyProps = {
	onAccept: (checked: boolean) => void
}

export const Privacy = ({ onAccept }: PrivacyProps): JSX.Element => {
	const termsAndConditions = ' Términos y condiciones '
	const privacyPolicy = ' Aviso de privacidad'

	const [terms, setTerms] = useState<boolean>(false)

	return (
		<PrivacyContainer isIOS={isIOS()}>
			<Checkbox
				id="privacy"
				name="privacy"
				topDistance="3.2px"
				value={terms}
				onChange={() => {
					setTerms(!terms)
					onAccept(!terms)
				}}
			/>
			<DescriptionLabel>
				Acepto los
				<ConditionsLink
					href="https://home.welbecare.com/clkn/https/terminosycondiciones.welbecare.com/"
					target="_blank"
					className="conditions-link"
					rel="noreferrer"
				>
					{termsAndConditions}
				</ConditionsLink>
				de Welbe, así como el
				<ConditionsLink
					href="https://home.welbecare.com/clkn/https/avisoprivacidad.welbecare.com/"
					target="_blank"
					className="conditions-link"
					rel="noreferrer"
				>
					{privacyPolicy}
				</ConditionsLink>
			</DescriptionLabel>
		</PrivacyContainer>
	)
}
